import { render, staticRenderFns } from "./PointCard.vue?vue&type=template&id=2a1b297b&scoped=true&"
import script from "./PointCard.vue?vue&type=script&lang=js&"
export * from "./PointCard.vue?vue&type=script&lang=js&"
import style0 from "./PointCard.vue?vue&type=style&index=0&id=2a1b297b&scoped=true&lang=css&"
import style1 from "./PointCard.vue?vue&type=style&index=1&id=2a1b297b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b297b",
  null
  
)

export default component.exports